import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import Head from "next/head";
import { useRouter } from "next/router";

const faqContent = {
  th: {
    title: "คำถามที่พบบ่อย",
    viewAll: "ดูคำถามทั้งหมด",
    items: [
      {
        question: "ร้าน Luxury29 มีสาขาอยู่ที่ไหนบ้าง?",
        locations: [
          {
            province: "เชียงใหม่",
            branches: [
              {
                href: "https://maps.app.goo.gl/Ure2aEqktuV71uQy6",
                text: "Central Festival เชียงใหม่ ชั้น 1",
              },
              {
                href: "https://maps.app.goo.gl/W77CgKvmpe9Pv92B6",
                text: "MAYA เชียงใหม่ ชั้น G",
              },
            ],
          },
          {
            province: "อุดรธานี",
            branches: [
              {
                href: "https://maps.app.goo.gl/CfEGzMF72BBN1R2m7",
                text: "Central อุดรธานี ชั้น 1",
              },
            ],
          },
          {
            province: "นนทบุรี",
            branches: [
              {
                href: "https://maps.app.goo.gl/bVWALUzEJn5x6PcV9",
                text: "Central Westgate จังหวัดนนทบุรี ชั้น 1",
              },
            ],
          },
          {
            province: "พิษณุโลก",
            branches: [
              {
                href: "https://maps.app.goo.gl/JJH5Fkd1vRBus8Qd9",
                text: "Central พิษณุโลก ชั้น 1",
              },
            ],
          },
        ],
      },
      {
        question: "ร้านเปิดและปิดกี่โมง?",
        intro:
          "Luxury29 มีหน้าร้านทั้งหมด 5 สาขา และเปิดให้บริการทุกวัน โดยเวลาเปิด-ปิดของแต่ละสาขาแตกต่างกัน ดังนี้",
        schedules: [
          {
            name: "Central Festival เชียงใหม่ ชั้น 1",
            hours: [
              "จันทร์–พฤหัสบดี: 11:00–21:30 น.",
              "ศุกร์: 11:00–22:00 น.",
              "เสาร์–อาทิตย์ และวันหยุดนักขัตฤกษ์: 10:00–22:00 น.",
            ],
          },
          {
            name: "MAYA เชียงใหม่ ชั้น G",
            hours: ["จันทร์–อาทิตย์: 10:00–22:00 น."],
          },
          {
            name: "Central อุดรธานี ชั้น 1",
            hours: [
              "จันทร์–ศุกร์: 10:30–21:00 น.",
              "เสาร์–อาทิตย์ และวันหยุดนักขัตฤกษ์: 10:00–21:00 น.",
            ],
          },
          {
            name: "Central Westgate จังหวัดนนทบุรี ชั้น 1",
            hours: ["จันทร์–อาทิตย์: 10:00–22:00 น."],
          },
          {
            name: "Central พิษณุโลก ชั้น 1",
            hours: [
              "จันทร์–ศุกร์: 11:00–21:00 น.",
              "เสาร์–อาทิตย์ และวันหยุดนักขัตฤกษ์: 10:00–21:00 น.",
            ],
          },
        ],
        note: "หมายเหตุ: เวลาเปิด-ปิดอาจมีการเปลี่ยนแปลงในบางวัน ช่วงเทศกาล หรือวันหยุดพิเศษ แนะนำตรวจสอบเวลาล่าสุดก่อนเดินทาง",
      },
      {
        question: "สั่งซื้อสินค้าได้ช่องทางใดบ้าง?",
        answers: [
          "คุณลูกค้า สามารถสั่งซื้อสินค้าได้ 2 ช่องทาง",
          "1. สั่งซื้อผ่านทางหน้าร้าน Luxury29 ทั้ง 5 สาขา ได้แก่",
          "- Central Festival เชียงใหม่ ชั้น 1",
          "- MAYA เชียงใหม่ ชั้น G",
          "- Central อุดรธานี ชั้น 1",
          "- Central Westgate จังหวัดนนทบุรี ชั้น 1",
          "- Central พิษณุโลก ชั้น 1",
          "2. สั่งซื้อผ่านช่องทางออนไลน์บนเว็บไซต์ https://luxury29.io/",
        ],
      },
    ],
  },
  en: {
    title: "Frequently Asked Questions",
    viewAll: "View All FAQ",
    items: [
      {
        question: "Where are Luxury29 stores located?",
        locations: [
          {
            province: "Chiang Mai",
            branches: [
              {
                href: "https://maps.app.goo.gl/Ure2aEqktuV71uQy6",
                text: "Central Festival Chiang Mai, 1st Floor",
              },
              {
                href: "https://maps.app.goo.gl/W77CgKvmpe9Pv92B6",
                text: "MAYA Chiang Mai, G Floor",
              },
            ],
          },
          {
            province: "Udonthani",
            branches: [
              {
                href: "https://maps.app.goo.gl/CfEGzMF72BBN1R2m7",
                text: "Central Udon Thani, 1st Floor",
              },
            ],
          },
          {
            province: "Nonthaburi",
            branches: [
              {
                href: "https://maps.app.goo.gl/bVWALUzEJn5x6PcV9",
                text: "Central Westgate, Nonthaburi, 1st Floor",
              },
            ],
          },
          {
            province: "Phitsanulok",
            branches: [
              {
                href: "https://maps.app.goo.gl/JJH5Fkd1vRBus8Qd9",
                text: "Central Phitsanulok, 1st Floor",
              },
            ],
          },
        ],
      },
      {
        question: "What time does the shop open and close?",
        intro:
          "Luxury29 has 5 physical stores. All stores are open daily, with different operating hours as follows:",
        schedules: [
          {
            name: "Central Festival Chiang Mai, 1st Floor",
            hours: [
              "Monday–Thursday: 11:00 a.m.–9:30 p.m.",
              "Friday: 11:00 a.m.–10:00 p.m.",
              "Saturday–Sunday and public holidays: 10:00 a.m.–10:00 p.m.",
            ],
          },
          {
            name: "MAYA Chiang Mai, G Floor",
            hours: ["Monday–Sunday: 10:00 a.m.–10:00 p.m."],
          },
          {
            name: "Central Udon Thani, 1st Floor",
            hours: [
              "Monday–Friday: 10:30 a.m.–9:00 p.m.",
              "Saturday–Sunday and public holidays: 10:00 a.m.–9:00 p.m.",
            ],
          },
          {
            name: "Central Westgate, Nonthaburi, 1st Floor",
            hours: ["Monday–Sunday: 10:00 a.m.–10:00 p.m."],
          },
          {
            name: "Central Phitsanulok, 1st Floor",
            hours: [
              "Monday–Friday: 11:00 a.m.–9:00 p.m.",
              "Saturday–Sunday and public holidays: 10:00 a.m.–9:00 p.m.",
            ],
          },
        ],
        note: "Note: Operating hours may change on certain days, during festivals, or on special holidays. Please check the latest hours before visiting.",
      },
      {
        question: "What channels can I order products?",
        answers: [
          "Customers can order products in 2 channels.",
          "1. Order at one of the 5 Luxury29 physical stores:",
          "- Central Festival Chiang Mai, 1st Floor",
          "- MAYA Chiang Mai, G Floor",
          "- Central Udon Thani, 1st Floor",
          "- Central Westgate, Nonthaburi, 1st Floor",
          "- Central Phitsanulok, 1st Floor",
          "2. Order via online channels on the website https://luxury29.io/",
        ],
      },
    ],
  },
};

const FAQ = ({ queryParam }) => {
  const { locale } = useRouter();
  const [openIndex, setOpenIndex] = useState(null);
  const content = locale === "th" ? faqContent.th : faqContent.en;
  const faqUrl = `/info/faq${queryParam ? `?${queryParam}` : ""}`;
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: content.items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.locations
          ? item.locations
              .map(
                (location) =>
                  `${location.province}: ${location.branches
                    .map((branch) => branch.text)
                    .join(", ")}`,
              )
              .join(". ")
          : item.schedules
            ? `${item.intro} ${item.schedules
                .map(
                  (schedule) => `${schedule.name}: ${schedule.hours.join(" ")}`,
                )
                .join(". ")} ${item.note}`
            : item.answers.join(" "),
      },
    })),
  };
  const shippingTrackingHowToJsonLd = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "How to track a Luxury29 shipment",
    description:
      "Follow these steps to check the delivery status of a Luxury29 order.",
    totalTime: "PT2M",
    step: [
      {
        "@type": "HowToStep",
        position: 1,
        name: "Log in",
        text: "Log in to the Luxury29 website.",
      },
      {
        "@type": "HowToStep",
        position: 2,
        name: "Open My Account",
        text: "Go to My Account.",
      },
      {
        "@type": "HowToStep",
        position: 3,
        name: "Open order history",
        text: "Select Order Status and History.",
      },
      {
        "@type": "HowToStep",
        position: 4,
        name: "Select an order",
        text: "Select the order you want to track.",
      },
    ],
  };

  const toggleItem = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <section className="mx-auto max-w-3xl px-4 py-10 md:py-14">
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(shippingTrackingHowToJsonLd),
          }}
        />
      </Head>
      <div className="text-center">
        <h2 className="text-xl font-semibold uppercase tracking-wide">
          {content.title}
        </h2>
        <div className="mx-auto mt-3 h-px w-24 bg-black" />
        {content.description && (
          <p className="mx-auto mt-4 max-w-lg text-base leading-7 text-gray-500">
            {content.description}
          </p>
        )}
      </div>

      <div className="mt-7 space-y-2">
        {content.items.map((item, index) => {
          const isOpen = openIndex === index;
          const panelId = `home-faq-answer-${index}`;

          return (
            <div
              key={item.question}
              className="overflow-hidden rounded border border-gray-200 bg-white shadow-sm"
            >
              <h3 className="m-0">
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left font-semibold text-black"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => toggleItem(index)}
                >
                  <span>{item.question}</span>
                  <span
                    aria-hidden="true"
                    className="shrink-0 text-xl font-light leading-none text-gray-700"
                  >
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
              </h3>

              <div
                id={panelId}
                className={`${
                  isOpen
                    ? "max-h-[5000px] border-t px-4 py-4"
                    : "max-h-0 overflow-hidden border-0 px-4 py-0"
                } space-y-4 border-gray-200 leading-7 text-gray-600`}
              >
                <p>{locale === "th" ? "ตอบ:" : "Answer:"}</p>

                {item.locations ? (
                  <ul className="m-0 list-none space-y-4 p-0">
                    {item.locations.map((location) => (
                      <li key={location.province} className="space-y-1">
                        <p className="font-semibold text-gray-800">
                          {location.province}
                        </p>
                        {location.branches.map((branch) => (
                          <a
                            key={branch.href}
                            href={branch.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-start gap-2 text-gray-600 hover:text-black"
                          >
                            <Image
                              src="/static/images/ic_location.png"
                              alt="location"
                              width={14}
                              height={14}
                              unoptimized
                              className="mt-1 shrink-0"
                            />
                            <p className="m-0">{branch.text}</p>
                          </a>
                        ))}
                      </li>
                    ))}
                  </ul>
                ) : item.schedules ? (
                  <>
                    <p>{item.intro}</p>
                    <table className="block w-full">
                      <tbody className="block">
                        {item.schedules.map((schedule) => (
                          <tr key={schedule.name} className="mb-4 block">
                            <td className="block">
                              <strong className="text-gray-800">
                                {schedule.name}
                              </strong>
                              {schedule.hours.map((hours) => (
                                <span key={hours} className="block">
                                  {hours}
                                </span>
                              ))}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <p className="text-sm">{item.note}</p>
                  </>
                ) : (
                  <>
                    <p>{item.answers[0]}</p>
                    <ol className="m-0 space-y-2 pl-5">
                      <li>
                        {item.answers[1]}
                        <ul className="mt-2 list-disc pl-5">
                          {item.answers.slice(2, 7).map((answer) => (
                            <li key={answer}>{answer.replace(/^-\s*/, "")}</li>
                          ))}
                        </ul>
                      </li>
                      <li>{item.answers[7]}</li>
                    </ol>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <Link
        href={faqUrl}
        prefetch={false}
        className="mt-7 flex w-full items-center justify-center gap-6 border border-gray-500 px-4 py-4 font-semibold uppercase tracking-wide text-black transition-colors hover:bg-black hover:text-white"
      >
        <span>{content.viewAll}</span>
        <span aria-hidden="true" className="text-xl font-normal leading-none">
          →
        </span>
      </Link>
    </section>
  );
};

export default FAQ;
